import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { QueryFactory } from 'services/api';

export type UseSignatureBlockInvalidationProps = {
  documentId?: number;
  revisionId?: number;
};

export const useSignatureBlockQueriesInvalidation = (
  props: UseSignatureBlockInvalidationProps,
) => {
  const queryClient = useQueryClient();
  return useCallback(async () => {
    // Query keys
    const revisionQueryKey = QueryFactory.RevisionQuery.getQueryKey(
      props.revisionId ?? 0,
    );
    const revisionDocumentsQueryKey = QueryFactory.DocumentQuery.searchQueryKey(
      props.revisionId ?? 0,
    );
    const documentQueryKey = QueryFactory.DocumentQuery.getQueryKey(
      props.documentId ?? 0,
    );
    const documentSigningStatusQueryKey =
      QueryFactory.DocumentSigningQuery.getDocumentsSigningStatusQueryKey(
        props.revisionId ?? 0,
      );
    const documentSignersAvailableRolesQueryKey =
      QueryFactory.DocumentSigningQuery.getDocumentSignersAvailableRolesQueryKey(
        props.revisionId ?? 0,
      );

    // Invalidate revision queries
    if (props.revisionId !== undefined) {
      await queryClient.invalidateQueries({
        queryKey: revisionQueryKey,
      });
      await queryClient.invalidateQueries({
        queryKey: revisionDocumentsQueryKey,
      });
    } else {
      await queryClient.invalidateQueries({
        queryKey: revisionQueryKey.slice(0, 2),
      });
      await queryClient.invalidateQueries({
        queryKey: revisionDocumentsQueryKey.slice(0, 2),
      });
    }

    // Invalidate document queries
    if (props.documentId !== undefined) {
      await queryClient.invalidateQueries({
        queryKey: documentSigningStatusQueryKey,
      });
      await queryClient.invalidateQueries({
        queryKey: documentSignersAvailableRolesQueryKey,
      });
      await queryClient.invalidateQueries({
        queryKey: documentQueryKey,
      });
    } else {
      await queryClient.invalidateQueries({
        queryKey: documentSigningStatusQueryKey.slice(0, 2),
      });
      await queryClient.invalidateQueries({
        queryKey: documentSignersAvailableRolesQueryKey.slice(0, 2),
      });
      await queryClient.invalidateQueries({
        queryKey: documentQueryKey.slice(0, 2),
      });
    }
  }, [props.documentId, props.revisionId, queryClient]);
};
